import { constant } from 'lodash/fp';
import { combineReducers } from 'redux';

import { keyById } from '@mews/fp';
import { createReducer } from '@mews/framework/redux';

import { BOOKING_RESTARTED } from '../../global/actionTypes';
import { FETCH_RESERVATION_GROUP_SUCCEEDED } from '../../reservationGroups/actionTypes';
import { FetchReservationGroupsResponse } from '../../reservationGroups/responseType';
import { PaymentRequestsData } from './types';

const dataInitialState: PaymentRequestsData = {};

const dataReducer = createReducer(dataInitialState, {
    [FETCH_RESERVATION_GROUP_SUCCEEDED]: (
        state: PaymentRequestsData,
        { paymentRequests }: FetchReservationGroupsResponse
    ) => ({
        ...state,
        ...keyById(paymentRequests),
    }),
    [BOOKING_RESTARTED]: constant(dataInitialState),
});

export const paymentRequests = combineReducers({
    data: dataReducer,
});
